import { useDocumentTitle } from 'react-commons';
import { Props } from '../MainLayout';
import useStyles from './useStyles';
import { useNavigation } from '../../../components/Navigation';
import { useDirectAccessAllowed, useProgress } from '../../../components/Shared';
import { useHistory } from 'react-router-dom';

const useMainLayout = (props: Props) => {
  const { navigationId, flow, progress, t, pageTitle, directAccess } = props;
  const history = useHistory();
  const pageTitleForUse = pageTitle && t ? t(pageTitle) : undefined;
  useDirectAccessAllowed(flow, directAccess);
  useProgress(progress);
  useDocumentTitle(pageTitleForUse);

  const handleHistoryBack = () => {
    history.goBack();
  };

  return {
    classes: useStyles(),
    navigation: useNavigation(navigationId),
    handleHistoryBack,
  };
};

export default useMainLayout;
